const IconTagSvg = (props: any) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 4.5C6 4.89782 5.84196 5.27936 5.56066 5.56066C5.27936 5.84196 4.89782 6 4.5 6C4.10218 6 3.72064 5.84196 3.43934 5.56066C3.15804 5.27936 3 4.89782 3 4.5C3 4.10218 3.15804 3.72064 3.43934 3.43934C3.72064 3.15804 4.10218 3 4.5 3C4.89782 3 5.27936 3.15804 5.56066 3.43934C5.84196 3.72064 6 4.10218 6 4.5V4.5ZM5 4.5C5 4.36739 4.94732 4.24021 4.85355 4.14645C4.75979 4.05268 4.63261 4 4.5 4C4.36739 4 4.24021 4.05268 4.14645 4.14645C4.05268 4.24021 4 4.36739 4 4.5C4 4.63261 4.05268 4.75979 4.14645 4.85355C4.24021 4.94732 4.36739 5 4.5 5C4.63261 5 4.75979 4.94732 4.85355 4.85355C4.94732 4.75979 5 4.63261 5 4.5Z"
        fill="white"
      />
      <path
        d="M2 1H6.586C6.85119 1.00006 7.10551 1.10545 7.293 1.293L14.293 8.293C14.4805 8.48053 14.5858 8.73484 14.5858 9C14.5858 9.26516 14.4805 9.51947 14.293 9.707L9.707 14.293C9.51947 14.4805 9.26516 14.5858 9 14.5858C8.73484 14.5858 8.48053 14.4805 8.293 14.293L1.293 7.293C1.10545 7.10551 1.00006 6.85119 1 6.586V2C1 1.73478 1.10536 1.48043 1.29289 1.29289C1.48043 1.10536 1.73478 1 2 1V1ZM2 6.586L9 13.586L13.586 9L6.586 2H2V6.586Z"
        fill="white"
      />
    </svg>
  )
}

export default IconTagSvg
